// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"dba183cb","747":"9a47fba5"}[chunkId] + ".chunk.css";
};